<div class="eui-modal-picker-container">
    <div class="eui-modal-picker__search-container eui-clearable-input-wrapper" [formGroup]="form">
        <input placeholder="{{ config.placeholder }}" formControlName="search">
        <span class="eui-clearable-input-wrapper__clear" (click)="clearInput()" *ngIf="form.get('search').value && form.get('search').value.length > 0"></span>
    </div>
    <div class="eui-modal-picker__items-container">
        <span class="eui-modal-picker__items__item col-3" *ngFor="let item of filteredData">
            <eui-chip [euiPrimary]="item.isSelected" [euiSecondary]="!item.isSelected" (click)="toggleSelected(item.id)">
                <span (click)="toggleSelected(item.id)">{{ item.label }}</span>
            </eui-chip>
        </span>
    </div>
</div>
